export default {
  '--avatar-background-color': '#303030',
  '--avatar-border': '2px solid #1e1e1e'
};